import { render, staticRenderFns } from "./RFP.vue?vue&type=template&id=2a6626e0"
import script from "./RFP.vue?vue&type=script&lang=js"
export * from "./RFP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports